const pad = (n) => String(n).padStart(2, "0")

// Clave local AAAA-MM-DD. toISOString() usa UTC y después de las 7 pm en Colombia ya devuelve "mañana"
export const toDateKey = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`

// new Date("AAAA-MM-DD") se interpreta en UTC y cae en el día anterior en Colombia
export const parseDateKey = (key) => {
  const [year, month, day] = key.split("-").map(Number)
  return new Date(year, month - 1, day)
}
